// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:22
import { CProcStep_abstract } from './../abstract/SagaSchema/CProcStep_abstract';
export class CProcStep extends CProcStep_abstract {}
